import axios from 'axios';
import { logout } from './userActions';

export const getAnnualReportData = (year = String(new Date().getFullYear())) => async (dispatch) => {
  try {
    const formData = new FormData();
    formData.append('year', year);

    const { data } = await axios.post(`/api/annual-report`, formData);

    if (data && data.status) {
      return data;
    } else if (data && !data.status) {
      console.log('Not logged in:', data.msg);
      dispatch(logout());
    } else {
      console.log('Empty data received');
      return {};
    }
  } catch (err) {
    console.error('Error fetching annual report data:', err);
    return {};
  }
};

